









































import { Component, Vue, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import AppMenu from "@/layout/AppMenu.vue";
import AppThemes from "@/themes/AppThemes.vue";
import ErrorBoundary from "@/components/common/ErrorBoundary.vue";

@Component({
  name: "App",
  components: {
    ErrorBoundary,
    AppThemes,
    AppMenu,
  },
})
export default class App extends Vue {
  public header: boolean = false;
  public footer: boolean = false;
  public hasSideMenu: boolean = false;

  @State("isCompleted", { namespace: "authModule" })
  private isCompleted!: boolean;

  @State("isLogged", { namespace: "authModule" })
  private isLogged!: boolean;

  @State("accessToken", { namespace: "authModule" })
  private accessToken!: boolean;

  @Watch("$route.matched", { immediate: true })
  private changeRoute(path: any): void {
    let page = "";
    let subpage = "";

    if (path.length) {
      page = path[0].hasOwnProperty("name") ? path[0].name : "";
    }

    if (path.length > 1) {
      subpage = path[1].hasOwnProperty("name") ? path[1].name : "";
    }

    this.hasSideMenu =
      (page === "practice" && subpage !== "practice-login") ||
      (page === "demo" && subpage !== "demo-login") ||
      this.isLogged;
  }

  get showSideMenu() {
    return this.hasSideMenu;
  }
}
